<template src="./CredentialsForm.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import { Routes } from "@/router/routes";
import FieldData from "@/services/fieldData";
import { VForm } from "vuetify/lib/components/VForm/VForm";

export default defineComponent({
    emits: ["submit"],
    props: { loading: { type: Boolean, default: false } },
    methods: {
        resetPassword(): void {
            this.$router.push(Routes.RequestPasswordReset);
        },
        async submit(): Promise<void> {
            if ((await (this.$refs.form as VForm).validate()).valid) {
                this.$emit("submit", this.email, this.password);
            }
        }
    },
    data() {
        return {
            emailData: new FieldData("Email-Address", {
                required: true,
                email: true
            }),
            passwordData: new FieldData("Password", {
                required: true,
                minLength: 6,
                maxLength: 40
            }),
            email: "",
            password: ""
        };
    }
});
</script>
